import { DashboardPage } from '../../../../ui/dashboard/DashboardPage';
import { Flex } from '../../../../ui/layout/Flex';
import { Typography } from '../../../../ui/typography/Typography';
import { useIsMobile } from '../../../../utils/getIsMobile';
import { useTranslation } from '../../../../utils/useTranslation';
import { DRAFT_MAX_WIDTH, STATS_MAX_WIDTH, TITLE } from '../constants';
import { GEO_HEIGHT, METRICS_HEIGHT, POSTS_HEIGHT, STATS_HEIGHT, UTM_HEIGHT } from './constants';

export const ContentPromotionSkeleton: React.FC<{}> = () => {
    const t = useTranslation();
    const isMobile = useIsMobile();

    return (
        <DashboardPage pb={{ xs: 12, sm: 7 }}>
            <Typography variant={isMobile ? 'title2' : 'title1'} weight="bold" mb={3} mt={2} px={2}>
                {t(TITLE)}
            </Typography>
            <Flex direction="row" width={{ xs: '100%', sm: 'auto' }}>
                <Flex width={{ xs: '100%', sm: DRAFT_MAX_WIDTH }} height="100%" borderRadius={2}>
                    <Flex
                        p={2}
                        borderRadius={2}
                        width="100%"
                        background="var(--background-primary)"
                        height={POSTS_HEIGHT}
                    />
                    <Flex
                        p={2}
                        mt={2}
                        borderRadius={2}
                        width="100%"
                        background="var(--background-primary)"
                        height={METRICS_HEIGHT}
                    />
                    <Flex
                        p={2}
                        mt={2}
                        borderRadius={2}
                        width="100%"
                        background="var(--background-primary)"
                        height={GEO_HEIGHT}
                    />
                    <Flex
                        p={2}
                        mt={2}
                        borderRadius={2}
                        width="100%"
                        background="var(--background-primary)"
                        height={UTM_HEIGHT}
                    />
                </Flex>
                {isMobile ? null : (
                    <Flex
                        width={STATS_MAX_WIDTH}
                        height={STATS_HEIGHT}
                        ml={2}
                        borderRadius={2}
                        background="var(--background-primary)"
                    />
                )}
            </Flex>
        </DashboardPage>
    );
};
